var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaude(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.359 14.215 7.947 7.7a7.972 7.972 0 0 0 1.144.921 1.026 1.026 0 0 0 1.1 0 7.937 7.937 0 0 0 1.143-.921l7.947-7.7a7.7 7.7 0 0 0 2.36-5.542 7.62 7.62 0 0 0 -12-6.251 7.632 7.632 0 0 0 -10.593 10.678 7.737 7.737 0 0 0 .952 1.115zm1.39-9.631a5.678 5.678 0 0 1 3.929-1.572 5.078 5.078 0 0 1 3.615 1.438 1.031 1.031 0 0 0 1.415 0 5.457 5.457 0 0 1 7.546.135 5.672 5.672 0 0 1 .7 7.37 5.708 5.708 0 0 1 -.708.824s-8.146 7.886-8.246 7.973c-.1-.087-8.25-7.973-8.25-7.973a5.724 5.724 0 0 1 -.708-.825 5.657 5.657 0 0 1 .707-7.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 12h2a1 1 0 0 0 .832-.445l1.124-1.685 2.187 3.645a1 1 0 0 0 .735.478 1.008 1.008 0 0 0 .829-.286l2.707-2.707h1.586a1 1 0 0 0 0-2h-2a1 1 0 0 0 -.707.293l-2.093 2.094-2.342-3.9a1 1 0 0 0 -.834-.487.952.952 0 0 0 -.856.445l-1.703 2.555h-1.465a1 1 0 0 0 0 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaude);
export default __webpack_public_path__ + "static/media/saude.433a079445df46a5bea25f1ef65291af.svg";
export { ForwardRef as ReactComponent };